/**
 * DevExtreme (esm/__internal/ui/drop_down_editor/m_utils.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { getOuterWidth } from "../../../core/utils/size";
import { hasWindow } from "../../../core/utils/window";
const getElementWidth = function ($element) {
  if (hasWindow()) {
    return getOuterWidth($element);
  }
};
const getSizeValue = function (size) {
  if (null === size) {
    size = void 0;
  }
  if ("function" === typeof size) {
    size = size();
  }
  return size;
};
export { getElementWidth, getSizeValue };